import { all } from 'redux-saga/effects'
import organizationListSagas from '../modules/organizationList/organizationsagas'
import treeSagas from '../components/TreeAll/saga'
import goodsSagas from '../modules/goodsdetailmodules/sagas'
import homeSagas from '../modules/homedata/sagas'
import dictSagas from '../modules/dict/sagas'

/**
 * 装载各 sagas 注意key值
 */
// eslint-disable-next-line
export default function* () {
  yield all([
    organizationListSagas(), // 组织列表
    treeSagas(), // 类目树
    goodsSagas(), // 物料
    homeSagas(),
    dictSagas(), // 字典数据
  ])
}
import { all } from 'redux-saga/effects'
import organizationListSagas from '../modules/organizationList/organizationsagas'
import treeSagas from '../components/TreeAll/saga'
import goodsSagas from '../modules/goodsdetailmodules/sagas'
import homeSagas from '../modules/homedata/sagas'
import dictSagas from '../modules/dict/sagas'

/**
 * 装载各 sagas 注意key值
 */
// eslint-disable-next-line
export default function* () {
  yield all([
    organizationListSagas(), // 组织列表
    treeSagas(), // 类目树
    goodsSagas(), // 物料
    homeSagas(),
    dictSagas(), // 字典数据
  ])
}
